<template>
  <div id="future">
    <div class="title">
      <img :src="require('../assets/imgs/'+ grade +'/title-banner1-type4.png')" alt />
      <div class="title-inner">
        <b-icon class="title-icon" name="future" :color="$util.mainTtleColor(grade)" :size="1.2"></b-icon>
        <p class="title-text" :style="{ color: $util.mainTtleColor(grade)}">未来三个月学习计划</p>
      </div>
    </div>
    <div class="text-content">
      <p v-if="content !== ''&&content !== 'null'" style="width: 100%;" v-html="content"></p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Future",
  props: {
    content: {},
    grade: {
      default: 6
    }
  },
  data() {
    return {};
  },
  mounted() {
    console.log(this.content);
  }
};
</script>
<style lang="scss">
#future {
  width: 100%;
  height: 300px;
  background: #fff;
  > .title {
    width: 100%;
    height: 280px;
    /*font-size: 0;*/
    position: relative;
    > img {
      width: 100%;
      height: 100%;
    }
    > .title-inner {
      position: absolute;
      top: 0;
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      padding-left: 5%;
      font-size: 1.2rem;
      color: #7f4224;
      > .title-icon {
        font-size: inherit;
        margin-right: 50px;
      }
      > .title-text {
        font-size: inherit;
      }
    }
  }
  > .text-content {
    width: 100%;
    min-height: 700px;
    background: #fff;
    padding: 1rem 5%;
    display: flex;
    justify-content: center;
    // align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Future.vue